import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { importLawyers, importTrainees } from '../../services/importService';

import pageStyles from '../Page.module.css';
import importStyles from './DataImportPage.module.css'; // سنقوم بإنشائه

// مكون فرعي قابل لإعادة الاستخدام لنموذج الاستيراد
const ImportForm: React.FC<{
  title: string;
  importFn: (file: File) => Promise<any>;
  templateLink: string;
}> = ({ title, importFn, templateLink }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const mutation = useMutation({
    mutationFn: importFn,
    onSuccess: (data) => {
      toast.success(data.message || 'تم الاستيراد بنجاح!');
      setSelectedFile(null);
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'فشل الاستيراد.');
    },
  });

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedFile(event.target.files[0]);
    }
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (selectedFile) {
      mutation.mutate(selectedFile);
    } else {
      toast.error('الرجاء اختيار ملف أولاً.');
    }
  };

  return (
    <div className={importStyles.importBox}>
      <h2 className={importStyles.boxTitle}>{title}</h2>
      <p className={importStyles.instructions}>
        الرجاء استخدام ملف Excel (.xlsx) بنفس تنسيق القالب.
        <a href={templateLink} download> تحميل القالب</a>
      </p>
      <form onSubmit={handleSubmit}>
        <input 
          type="file" 
          onChange={handleFileChange} 
          accept=".xlsx"
          className={importStyles.fileInput}
        />
        {selectedFile && <p className={importStyles.fileName}>الملف المختار: {selectedFile.name}</p>}
        <button 
          type="submit" 
          disabled={!selectedFile || mutation.isPending}
          className="button primary"
        >
          {mutation.isPending ? 'جاري الاستيراد...' : 'استيراد الآن'}
        </button>
      </form>
    </div>
  );
};


const DataImportPage: React.FC = () => {
  return (
    <div className={pageStyles.pageContainer}>
      <h1 className={pageStyles.pageTitle}>استيراد البيانات من Excel</h1>
      <div className={importStyles.container}>
        <ImportForm 
          title="استيراد بيانات المحامين"
          importFn={importLawyers}
          templateLink="/templates/lawyers_template.xlsx" // مسار وهمي للقالب
        />
        <ImportForm 
          title="استيراد بيانات المتدربين"
          importFn={importTrainees}
          templateLink="/templates/trainees_template.xlsx" // مسار وهمي للقالب
        />
      </div>
    </div>
  );
};

export default DataImportPage;
